import React from 'react';

const ProtectedLayout: React.FC = () => {
    return <h1>Protected</h1>;
};

export default ProtectedLayout;
